export default __webpack_public_path__ + "static/media/favicon.491942e8.ico";